<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-table outlined 
                         hover
                         sticky-column 
                         responsive
                         :fields="fields" 
                         :items="items" 
                         :busy="items == 0"
                         :current-page="currentPage" 
                         :per-page="perPage"
                         @row-clicked="rowQnaOpenModal">
                         <div slot="table-busy" class="text-center my-2">
                            <strong>데이터가 없습니다.</strong>
                        </div>
                </b-table>
            </b-col>
            <b-col sm="12">
                <b-pagination v-model="currentPage" 
                            :totalRows="totalRows" 
                            :per-page="perPage"
                            align="center"></b-pagination>
            </b-col>
        </b-row>

        <UserQnaDetailModal v-bind:formModal="formModal" v-bind:item="item" />
    </div>
</template>
<script>
import UserQnaDetailModal from './UserQnaDetailModal';
import { EventBus } from "../../../../../event-bus";

export default {
    name: "userQnaList",
    props: {
        userId: {
            type: String,
            default: ""
        },
    },
    created() {
      // 이벤트 버스 선언
      EventBus.$on('callQnaCloseModal', () => {
        this.closeQnaModal();
      });
    },
    data() {
        return {
            fields: [
                , { 'type_name':      { 'label': '분류', thClass: 'thClass_w10', tdClass: 'textAlignCenter' } }
                , { 'title':          { 'label': '제목' , thClass: 'thClass_w50', tdClass: 'tdClass' } }
                , { 'reg_date':       { 'label': '등록일', thClass: 'thClass_w10', tdClass: 'textAlignCenter' } }
                , { 'reply_date':     { 'label': '최종응대일자', thClass: 'thClass_w10', tdClass: 'textAlignCenter' } }
                , { 'reply_reg_user': { 'label': '답변자', thClass: 'thClass_w10', tdClass: 'textAlignCenter' } }
                , { 'qastatus_name':  { 'label': '상태', thClass: 'thClass_w10', tdClass: 'textAlignCenter' } }
            ],
            queryParams: {
                name: '',
                content: '',
                searchType: 'all',
                qastatus: '0',
            },
            items: [],
            currentPage: 1,
            perPage:10,
            totalRows:0,
            formModal: false,
            item: {},
        }
    },
    watch: {
        userId: function (value, oldValue) {
            this.findQNAList();
        },
    },
    methods: {
        findQNAList() {
            this.queryParams.keyword = this.userId;
            this.queryParams.searchType = 'user_id';
            this.queryParams.qaSearchType = 'all';
            var token = sessionStorage.getItem("myToken");
            var param = encodeURI(JSON.stringify(this.queryParams));

            var data = new FormData();
            data.append('objs', param);

            this.$http.post('/api/select/qaList?access_token=' + token, data, null)
                .then((result) => {
                    const { data } = result;
                    this.items = data;
                    this.totalRows = this.items.length;
                });
        },
        rowQnaOpenModal(item, index) {
            // console.log(item);
            this.item = item;
            this.formModal = true;
        },
        closeQnaModal() {
            this.formModal = false;
        },
    },
    components: {
        UserQnaDetailModal,
    }
}
</script>


// WEBPACK FOOTER //
// src/views/user/userDetail/component/tabs/qna/UserQnaList.vue